import i18next from 'i18next'
import * as React from 'react'
import { InviewProps } from '../blocksState'
import { LinkGridBlockLayout } from '../linkGridBlockLayout'
import { AllCases } from './allCasesBlockState'


export type AllCasesBlockProps = {
  index: number
  inview?: InviewProps
  title?: React.ReactNode
  children: AllCases
}

export function AllCasesBlockLayout(props: AllCasesBlockProps) {
  return props.children.length > 0 ? (
    <LinkGridBlockLayout
      index={props.index}
      title={props.title}
      inview={props.inview}
      withImages={false}
      items={props.children.map(x => ({
        title: x.HeaderTitle,
        intro: x.HeaderDescription,
        link: {
          url: x.AbsolutePath,
          title: x.HeaderTitle
        }
      }))}
    />
  ) : null
}

